<div class="teachers-page">
  <div class="page-head">
    <div>
      <h1 class="page-title">Teachers</h1>
      <p class="page-sub">Manage teacher accounts for your school (same tenant as students).</p>
    </div>
    <button mat-flat-button color="primary" type="button" (click)="openAddTeacher()" [disabled]="tenantId == null">
      <mat-icon>person_add</mat-icon>
      Add teacher
    </button>
  </div>

  <mat-card *ngIf="tenantId != null" class="context-card">
    <mat-card-content>
      <div class="context-row">
        <mat-icon color="primary">apartment</mat-icon>
        <div>
          <div class="context-label">School</div>
          <div class="context-value">{{ schoolName || '—' }}</div>
        </div>
        <div class="context-id">
          <span class="context-label">Tenant / school id</span>
          <span class="context-value mono">{{ tenantId }}</span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="tenantId == null" class="warn-card">
    <mat-card-content>
      <mat-icon color="warn">warning</mat-icon>
      <p>
        No tenant id in session. Return <code>tenantId</code> / <code>school.id</code> from login, or put
        <code>tenantId</code> in the JWT — the app reads both (body wins over JWT).
      </p>
    </mat-card-content>
  </mat-card>

  <mat-card class="list-card">
    <mat-card-title>Teachers</mat-card-title>
    <mat-card-subtitle>Users with role ROLE_TEACHER from GET /api/v1/users (tenant-scoped).</mat-card-subtitle>
    <mat-card-content>
      <div *ngIf="loadingList" class="list-loading">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
      <table mat-table [dataSource]="dataSource" *ngIf="!loadingList" class="teachers-table">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let row">{{ row.firstName }} {{ row.lastName }}</td>
        </ng-container>
        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef>Username</th>
          <td mat-cell *matCellDef="let row">{{ row.username }}</td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let row">{{ row.email }}</td>
        </ng-container>
        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef>Phone</th>
          <td mat-cell *matCellDef="let row">{{ row.phoneNumber || row.mobileNumber }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <p *ngIf="!loadingList && !dataSource.data.length" class="empty">No teachers yet. Use Add teacher, or ensure GET /api/v1/users returns roles.</p>
    </mat-card-content>
  </mat-card>
</div>
